import { Skeleton } from "antd"

const TimesheetSkeleton = () => (
  <div>
    <div className="flex items-center gap-7">
      {Array.from({ length: 7 }).map((_, key) => (
        <Skeleton.Input
          key={key}
          active
          size="small"
          style={{ width: 50 }}
        />
      ))}
    </div>
    <div className="border-2 border-[#E2E8F0] rounded-md p-2 mt-2 flex items-center justify-between">
      <div className="flex items-center gap-5">
        <Skeleton.Input
          active
          size="small"
          style={{ width: 20 }}
        />
        <Skeleton.Input
          active
          size="small"
          style={{ width: 200 }}
        />
      </div>
      <Skeleton.Input
        active
        size="small"
        style={{ width: 100 }}
      />
    </div>
  </div>
)

export default TimesheetSkeleton
